import { gsap } from "gsap";
import { SplashView } from '../SplashController';
import { SanJumpData } from '../../../server/base/IData';
import { IDimOrientation, ResizeHelper } from "../../../../core/utils/ResizeHelper";
import { SanQuentin2 } from "../../../SanQuentin2";
import { TranslationConfig } from "../../../config/translate/TranslationConfig";
import { TextStyleConfig } from "../../../config/translate/TextStyleConfig";
import { Helper } from "../../../../core/utils/Helper";
import { GameData } from "../../../server/data/GameData";
import { GameSetting } from "../../../../core/setting/GameSetting";
import { MathHelper } from "../../../../core/utils/MathHelper";
import { BigWinPosterState } from "../../poster/BigWinPoster";
import { SoundManager } from "../../../config/sound/SoundManager";
import { SoundConfig } from "../../../config/sound/SoundConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { ParticlesManager } from "../../particles/ParticlesManager";

export interface totalPresentationJWFS {
    jwData: SanJumpData[];
    fs: number;
}

export class SplashBrokenBank extends PIXI.Container implements SplashView {

    initiated: boolean = false;

    protected readonly layoutDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(0, -200),
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(0, -200)
        }
    };

    protected _timeLine: gsap.core.Timeline;

    protected _gfxBg: PIXI.Graphics;

    protected _isFS: boolean;
    protected _isNormalOrSetup: boolean;
    protected brokeTheBank: boolean;

    protected _spPlaceHolder: PIXI.Sprite;
    private showTotW: boolean = false;

    private skinResult:string = "";
    private skinPaths:string[] = ["electric","firing","gas","injection","pardon"];

    private ammToCount: number;

    constructor() {
        super();
    }

    setData(data: GameData) {
        if (!this.initiated) this.initAnimations();
        this.ammToCount = data.Win.totalWin;
        this.showTotW = data.Win.shouldShowTotalWin;
        this._isNormalOrSetup = data.isFSSetup || data.isNormalMode;

        let indxVal = ["Execution1","Execution2","Execution3","Execution4","Execution5"].findIndex(v => v == data.raw.brokeTheBankExecutionType);
        if(indxVal == -1) indxVal = MathHelper.randomIntInRange(0,this.skinPaths.length-1);
        else indxVal = MathHelper.clamp(indxVal, 0, this.skinPaths.length-1);
        this.skinResult =  GameSetting.JuriGFXCensorSettings || GameSetting.JuriGFXUSCensorSettings ? "pardon" : this.skinPaths[indxVal];

        // this._spPlaceHolder.texture = SanQuentin2.assetLoader.getTextures(this.path + indxVal)[0];
    }

    protected createGraphic(): void {
        const maxAreaSize: number = 3000;
        this._gfxBg = this.addChild(new PIXI.Graphics());
        this._gfxBg.beginFill(0x000000, 0.85);
        this._gfxBg.drawRect(-maxAreaSize * 0.5, -maxAreaSize * 0.5, maxAreaSize, maxAreaSize);
        this._gfxBg.endFill();
    }

    protected initAnimations(): void {
        this.createGraphic();

        // this._spPlaceHolder = this.addChild(new PIXI.Sprite());
        // this._spPlaceHolder.anchor.set(0.5);
        // this._spPlaceHolder.position.y = 180;

        // this._txt_TOTAL_BROKE = this.createText(GameSetting.translate(TranslationConfig.COLLECTED_JUMPING_WILDS));
        // this._txt_TOTAL_BROKE.style = TextStyleConfig.COLLECT_TEXT;
        // this._txt_TOTAL_BROKE.text = "200 000X";
        // this._txt_TOTAL_BROKE.scale.set(1.5);

        this.visible = false;
        this.initiated = true;
        this.onResize();
    }

    private createText(val: string): PIXI.Text {
        const temp: PIXI.Text = new PIXI.Text(GameSetting.translate(val));
        temp.style = TextStyleConfig.BONUS_RESULT_TEXT;
        temp.anchor.set(0.5, 0.5);
        this.addChild(temp);
        return temp;
    }

    public play(): gsap.core.Timeline {
        
        if (!this.initiated) this.initAnimations();

        this._timeLine = Helper.setTimeline(this._timeLine, {
            onStart: () => {
                this.visible = true;
                this.alpha = 1;
            }
        });
        SoundManager.playSoundEffect(SoundConfig.CAP_WIN_COUNT);
        SanQuentin2.BigWinPoster.setCap(true);
        SanQuentin2.counter.isCapWinPos = true;
        const durr = SanQuentin2.BigWinPoster.play(BigWinPosterState.BIG_WIN, { animation: "capwin",skinType:this.skinResult, showOnEnd:true}).duration();
        this._timeLine.add(SanQuentin2.counter.play(0, this.ammToCount, durr-1.2), 0);
        this._timeLine.fromTo(this._gfxBg, { alpha: 0 }, { duration: 2, alpha: 1 }, 0);
        SanQuentin2.particleManagerBehind.paperRain.enableEmit(true);
        this._timeLine.add(() => 
            {
                SanQuentin2.counter.bounceHit(4,0.4);
                SlotGame.keypadPlugin.setWin(this.ammToCount,this.showTotW);
            },durr-1.2)

        this._timeLine.add(() => 
            {
                SanQuentin2.BigWinPoster.play(BigWinPosterState.BIG_WIN, { animation: "capwin_end",skinType:this.skinResult,loop:true})
                SoundManager.playSoundEffect(SoundConfig.CAP_WIN_MUSIC, Infinity);
            },durr)
        // this._timeLine.fromTo([this._txt_TOTAL_BROKE], { alpha: 0 }, { duration: 0.3, alpha: 1 });
        this._timeLine.add(() => {
            SanQuentin2.counter.stop(this.ammToCount, 1, 0, true);
        },durr);
        this._timeLine.to(this,{duration:1});

        return this._timeLine;
    }

    public stop(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, {
            onComplete: () => {
                SanQuentin2.counter.isCapWinPos = false;
                this.visible = false;
                SanQuentin2.BigWinPoster.setCap(false);
            }
        });
        SanQuentin2.particleManagerBehind.paperRain.enableEmit(false);
        SoundManager.playSoundEffect(SoundConfig.CAP_WIN_END);
        SoundManager.stopSoundEffect(SoundConfig.CAP_WIN_COUNT);
        SoundManager.stopSoundEffect(SoundConfig.CAP_WIN_MUSIC);
        this._timeLine.add(SanQuentin2.BigWinPoster.stop(0.35),0);
        this._timeLine.to(this, 0.35, { alpha: 0 },0);
        return this._timeLine;
    }

    public onResize(): void {
        this.position = ResizeHelper.calcDim(this.layoutDim).position;
        this.scale = ResizeHelper.calcDim(this.layoutDim).scale;
    }
}
